import * as React from 'react';

import { Wrapper, CircleWrapper, BackCircle, FrontCircle } from './styles';

interface ProgressCircleProps {
	percentage: number;
	size: number;
	strokeWidth: number;
}

const MAX_VALUE = 100;

const ProgressCircle = ({ percentage, size, strokeWidth }: ProgressCircleProps) => {
	const coordinate = Math.round(size / 2);
	const radius = Math.round(coordinate - (strokeWidth / 2));
	const circleLength = radius * 2 * Math.PI;
	const currentPercentsLength = (1 - (percentage / MAX_VALUE)) * circleLength;

	return (
		<Wrapper>
			<div>{percentage}%</div>
			<CircleWrapper
				width={size}
				height={size}
				viewBox={`0 0 ${size} ${size}`}
			>
				<BackCircle
					r={radius}
					cx={coordinate}
					cy={coordinate}
					strokeDasharray={circleLength}
					strokeWidth={strokeWidth}
				/>
				<FrontCircle
					r={radius}
					cx={coordinate}
					cy={coordinate}
					strokeDasharray={circleLength}
					strokeDashoffset={currentPercentsLength}
					strokeWidth={strokeWidth}
				/>
			</CircleWrapper>
		</Wrapper>
	);
};

export default ProgressCircle;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProgressCircle/index.tsx